import { render, staticRenderFns } from "./Cobranza.vue?vue&type=template&id=41050b86&scoped=true"
import script from "./Cobranza.vue?vue&type=script&lang=js"
export * from "./Cobranza.vue?vue&type=script&lang=js"
import style0 from "./Cobranza.vue?vue&type=style&index=0&id=41050b86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41050b86",
  null
  
)

export default component.exports